<template>
  <section class="erro">
    <div class="container">
      <div class="box">
        <div class="row">
          <div class="col-12">
            <div class="num-erro d-flex align-items-center justify-content-center">
              <i class="fas fa-exclamation-triangle mr-2"></i>
              <p>404</p>
            </div>
          </div>
          <div class="col-12 col-md-6 text-center">
            <img :src="require('@/assets/img/source.gif')" alt="Erro 404" class="img-fluid mb-3" />
          </div>
          <div class="col-12 col-md-6 text-center text-md-left erro-msg">
            <p>Ops!</p>
            <p>A página que você tentou acessar não existe, ou o link que você usou está com algum erro. </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PaginaNaoEncontradaView'
}
</script>

<style scoped>
  section.erro {
    background-color: #3b94f1;
    padding-top: 100px;
    padding-bottom: 50px;
  }

  section.erro div.box {
    background-color: #fff;
    padding: 40px;
    border-radius: 10px;
  }

  section.erro div.num-erro {
    border: 3px solid #3b94f1;
    text-transform: uppercase;
    padding: 20px;
    text-align: center;
    font-size: 40px;
    background-color: #3b94f1;
    margin-bottom: 40px;
    border-radius: 8px;
  }

  section.erro div.num-erro i {
    font-size: 30px;
    color: #fff;
    opacity: .5;
  }

  section.erro div.num-erro p {
    font-size: 40px;
    color: #fff;
    font-family: Jura,sans-serif;
    line-height: 33px;
  }

  section.erro img {
    max-height: 300px;
  }

  section.erro div.erro-msg p:first-child {
    color: #3b94f1;
    font-size: 60px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  section.erro div.erro-msg p:nth-child(2) {
    color: #3b94f1;
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  section.erro div.erro-msg p:last-child {
    font-size: 20px;
    line-height: 25px;
  }

  section.erro div.erro-msg p {
    line-height: inherit;
  }
</style>
